<template>
  <v-layout row wrap class="user-block">
    <v-flex xs12>
      <v-icon account_box>account_box</v-icon>
    </v-flex>
    <v-flex xs12 class="username">
      {{profile.username}}
    </v-flex>
    <v-flex xs12 class="user-role">
      {{profile.companyName}}
    </v-flex>
    <!-- <div @click="handleChangePassword" class="small-btn primary--text">
      Change Password
    </div> -->
    <div @click="handleLogout" class="small-btn font-weight-medium primary--text mt-4">
      LOG OUT
    </div>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'

import * as userUtils from '@/utils/user'

export default {
  name: 'UserInfo',
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['profile'])
  },
  methods: {
    handleLogout () {
      this.$emit('on-logout')
    },
    handleChangePassword () {
      this.$emit('on-change-password')
    }
  }
}

</script>

<style lang="scss" scoped>
.user-block{
  border: 1px solid #2a63d5;
  border-radius: 4px;
  padding: 14px 18px;
  margin: auto 17px;
  font-size: 14px;
  .username{
    font-family: 'Roboto';
    font-weight: 500;
  }
  .user-company-namerole{
    opacity: .5;
  }
  .small-btn{
    padding-top: 5px;
    cursor: pointer;
  }
}
</style>
